import React from 'react';
import Box from '../../components/Box/Box';
import { TextBodySmall } from '../../components/Text';
import { SecondaryButton } from '../../components/Button';
import TSegmentedControl from './types/TSegmentedControl';
import getComponentClassNames from '../../utils/className/getComponentClassNames';

const classNames = getComponentClassNames(['SegmentedControl'], ['track', 'title']);

const SegmentedControl = ({
  labelText,
  options,
  value,
  onChange,
  className,
  ariaLabel,
  ...rest
}: TSegmentedControl) => {
  return (
    <Box as="div" name="SegmentedControl" className={className} {...rest}>
      {labelText && (
        <TextBodySmall as="div" color="text-primary" strong>
          {labelText}
        </TextBodySmall>
      )}
      <div className={classNames.track} role="group" aria-label={ariaLabel || labelText}>
        {options.map((option) => {
          const isActive = option.value === value;
          return (
            <SecondaryButton
              key={option.value}
              type="button"
              className={`hz-SegmentedControl-segment${isActive ? ' is-active' : ''}`}
              onClick={() => onChange(option.value)}
              aria-pressed={isActive}
            >
              {option.label}
            </SecondaryButton>
          );
        })}
      </div>
    </Box>
  );
};

export default SegmentedControl;
